import { render, staticRenderFns } from "./applcation-form-9.vue?vue&type=template&id=a8a28f74&scoped=true&"
import script from "./applcation-form-9.vue?vue&type=script&lang=ts&"
export * from "./applcation-form-9.vue?vue&type=script&lang=ts&"
import style0 from "./applcation-form-9.vue?vue&type=style&index=0&id=a8a28f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a28f74",
  null
  
)

export default component.exports